/**
 * 送信ボタンの無効表示（data 属性駆動。ログイン画面 SCR-01 / 試作サイト LoginForm 準拠）
 *
 * マークアップ規約:
 *   <form data-lms-submit-enable>
 *     <input required type="email" pattern="...">   ← HTML 標準の制約で活性条件を表す
 *     <input required minlength="8" type="password">
 *     <button type="submit" aria-describedby="…">Log in</button>
 *   </form>
 *
 * 挙動:
 *   フォーム内の入力が HTML 標準の制約（required / minlength / type=email / pattern 等）を
 *   すべて満たすまで、submit ボタンに aria-disabled="true" を付ける（見た目の減光は CSS）。
 *   入力のたびに再判定する。
 *
 * disabled 属性を使わない理由（2026-07-27 の UI/UX レビュー ログイン #4 / #10）:
 *   - disabled な default button があると HTML の implicit submission（入力欄での Enter）が
 *     行われず、ブラウザ標準の制約検証 UI（「メールアドレスに『@』を挿入してください」の
 *     バブル）も起動しない。画面が完全に無反応になり、原因を知る手段が消える
 *   - disabled な <button> はフォーカス不能なので、キーボード利用者はボタンの存在にも
 *     「なぜ押せないか」にも到達できない
 *   aria-disabled は「無効に見える・支援技術にも無効と伝わる」一方で「フォーカスは当たる」
 *   「クリック・Enter は通る」ため、両方を同時に満たす。
 *
 * 送信を JS で止める処理は書かない:
 *   aria-disabled を付ける条件（!form.checkValidity()）と、ブラウザが送信を止める条件は
 *   同一である。preventDefault や reportValidity を足すと同じ判定が二重になり、片方だけ
 *   条件が変わったときに矛盾する。JS が動かない環境では減光もされないが、送信時に
 *   ブラウザ標準の検証が働くのでログインは可能（プログレッシブエンハンスメント）。
 */
export function initSubmitGuard(scope: ParentNode = document): void {
  scope.querySelectorAll<HTMLFormElement>("form[data-lms-submit-enable]").forEach((form) => {
    if (form.dataset["lmsSubmitEnableReady"] === "1") return;
    form.dataset["lmsSubmitEnableReady"] = "1";

    const button = form.querySelector<HTMLButtonElement>('button[type="submit"]');
    if (!button) return;

    // checkValidity() はブラウザ標準の制約検証を行う（UI バブルは出さない）
    const sync = (): void => {
      if (form.checkValidity()) {
        button.removeAttribute("aria-disabled");
      } else {
        button.setAttribute("aria-disabled", "true");
      }
    };

    sync();
    form.addEventListener("input", sync);
    form.addEventListener("change", sync);
  });
}
